import React from 'react'

const LiveContext = React.createContext({})
const ItemContext = React.createContext({})

export { LiveContext, ItemContext }
